// This function must also work inside browser. Thereof we first need to make typeof check,
// because we do not polyfill 'process' anymore.
export const isInsideUnitTesting = (): boolean =>
  typeof process !== 'undefined' &&
  (process.env.UNIT_TESTING === 'true' ||
    process.env.UNIT_UI_TESTING === 'true')
